(function(){
  'use strict';
  const root=document.querySelector('.yi2c-art-guide');
  const node=document.getElementById('yi2c-art-guide-data');
  if(!root||!node)return;
  const data=JSON.parse(node.textContent);
  const storageKey='yi2c-original-art-guide-v1';
  const state={style:Object.assign({},data.style),cards:{},showMarks:false};
  function recipe(s){
    return 'Medium: '+s.medium+'.\nLine: '+s.line+'.\nTexture: '+s.texture+'.\nDetail: '+s.detail+'.\nColour family: '+s.palette+'.\nImage shape: '+s.shape+'.';
  }
  function defaultFields(card){const values={};card.fields.forEach(function(f){values[f.key]=f.default;});return values;}
  function compile(card,fields,s){
    const values=Object.assign({},fields,{style:recipe(s)});
    if(Object.prototype.hasOwnProperty.call(fields,'reference')){
      values.referenceInstruction=fields.reference==='Work entirely from the written recipe'
        ?'Work entirely from the visual recipe below. No image upload is required. Reuse its paint handling, line, texture, detail and colour family.'
        :'Use my attached own approved first artwork only as the benchmark for its visual finish. Follow its paint handling, line, texture, detail and characteristic shapes; create a different scene and composition.';
    }
    return card.template.replace(/\{\{([a-zA-Z]+)\}\}/g,function(all,key){return String(values[key]===undefined?'':values[key]);});
  }
  data.prompts.forEach(function(card){const fields=defaultFields(card);state.cards[card.id]={fields:fields,prompt:compile(card,fields,state.style),manual:false};});
  try{
    const saved=JSON.parse(localStorage.getItem(storageKey)||'null');
    if(saved&&saved.version===1){
      Object.keys(state.style).forEach(function(k){if(typeof saved.style?.[k]==='string')state.style[k]=saved.style[k];});
      data.prompts.forEach(function(card){
        const prior=saved.cards?.[card.id];
        if(prior&&typeof prior.prompt==='string'&&typeof prior.manual==='boolean'){
          Object.keys(state.cards[card.id].fields).forEach(function(k){if(typeof prior.fields?.[k]==='string')state.cards[card.id].fields[k]=prior.fields[k];});
          state.cards[card.id].prompt=prior.prompt;state.cards[card.id].manual=prior.manual;
        }
      });
      state.showMarks=Boolean(saved.showMarks);
    }
  }catch(_){}
  function save(){try{localStorage.setItem(storageKey,JSON.stringify({version:1,style:state.style,cards:state.cards,showMarks:state.showMarks}));}catch(_){}}
  function status(id,message){const el=root.querySelector('[data-status="'+id+'"]');if(el)el.textContent=message;}
  root.querySelectorAll('[data-style]').forEach(function(input){
    input.value=state.style[input.dataset.style];
    input.addEventListener('input',function(){state.style[input.dataset.style]=input.value;root.querySelector('#style-recipe').value=recipe(state.style);status('style','Style edited. Apply it when you are ready; your complete prompts are kept.');save();});
  });
  root.querySelector('#style-recipe').value=recipe(state.style);
  data.prompts.forEach(function(card){
    const box=root.querySelector('[data-card="'+card.id+'"]');
    const textarea=box.querySelector('.complete-prompt');
    const local=state.cards[card.id];
    textarea.value=local.prompt;
    box.querySelectorAll('[data-field]').forEach(function(input){
      input.value=local.fields[input.dataset.field];
      input.addEventListener('input',function(){local.fields[input.dataset.field]=input.value;status(card.id,'Details changed. Choose “Apply details — replace prompt” when ready.');save();});
      input.addEventListener('change',function(){local.fields[input.dataset.field]=input.value;save();});
    });
    textarea.addEventListener('input',function(){local.prompt=textarea.value;local.manual=true;status(card.id,'Your manual prompt edits are kept.');save();});
    box.querySelector('[data-action="apply"]').addEventListener('click',function(){
      local.prompt=compile(card,local.fields,state.style);local.manual=false;textarea.value=local.prompt;
      status(card.id,'Complete prompt updated with these details and your current style.');save();
    });
    box.querySelector('[data-action="reset"]').addEventListener('click',function(){
      local.fields=defaultFields(card);local.prompt=compile(card,local.fields,state.style);local.manual=false;
      box.querySelectorAll('[data-field]').forEach(function(input){input.value=local.fields[input.dataset.field];});
      textarea.value=local.prompt;status(card.id,'Default details restored. Your collection style is retained.');save();
    });
    box.querySelector('[data-action="copy"]').addEventListener('click',function(){copy(textarea,card.id);});
  });
  async function copy(textarea,id){
    try{if(!navigator.clipboard?.writeText)throw new Error('Fallback');await navigator.clipboard.writeText(textarea.value);status(id,'Complete text copied.');}
    catch(_){
      textarea.focus();textarea.select();
      let copied=false;try{copied=document.execCommand('copy');}catch(_){}
      status(id,copied?'Complete text copied.':'Text selected. Use your device’s Copy command.');
    }
  }
  root.querySelector('#apply-style').addEventListener('click',function(){
    let updated=0,kept=0;
    data.prompts.forEach(function(card){
      if(!card.usesStyle)return;
      const local=state.cards[card.id];if(local.manual){kept++;return;}
      local.prompt=compile(card,local.fields,state.style);root.querySelector('[data-card="'+card.id+'"] .complete-prompt').value=local.prompt;updated++;
    });
    status('style','Style applied to '+updated+' untouched prompts. '+kept+' manually edited prompts kept.');save();
  });
  root.querySelector('#copy-style').addEventListener('click',function(){copy(root.querySelector('#style-recipe'),'style');});
  root.querySelector('#reset-style').addEventListener('click',function(){
    state.style=Object.assign({},data.style);root.querySelectorAll('[data-style]').forEach(function(i){i.value=state.style[i.dataset.style];});
    root.querySelector('#style-recipe').value=recipe(state.style);status('style','Default style restored. Existing complete prompts are kept until you apply it.');save();
  });
  const toggle=root.querySelector('#show-signatures');toggle.checked=state.showMarks;root.classList.toggle('show-marks',state.showMarks);
  toggle.addEventListener('change',function(){state.showMarks=toggle.checked;root.classList.toggle('show-marks',state.showMarks);save();});
  window.YI2CArtGuide={compile:compile,recipe:recipe,data:data,state:state};
})();
